import React, { useState, useEffect } from "react";
import { Button, DatePicker, Select,Space } from "antd";
import dayjs from "dayjs";
import "./filtertimesheet.scss"; 
import useSettingstore from "../../store/settings.store";
import useTeamTimeSheetStore from "../../store/teamtimesheet";
import useProjectStore from "../../store/projectModal.store";

function FilterTimeSheet({
  filtername,
  handleFilter,
  enableProject = false,
  enableUsers = false,
  enableMonths = false,
  enableYear = false,
  initProject,
  initMonth,
  initUsers,
  initYear,
  allUsers
}) {
  const [filterParamProjects, setFilterProject] = useState(initProject);
  const [filterParamUser, setFilterUser] = useState(initUsers);
  const [filterParamMonth, setFilterMonth] = useState(initMonth);
  const [filterParamYear, setFilterYear] = useState(initYear);

  const { getTeamTimeSheetAproveUsersList, approveUserList,resetAprroveUsersListFlag,approveUserListFlag} = useTeamTimeSheetStore();
  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();
  const [aUserList, setAUserList] = useState();

  const aUserAll = { value: "All", label: "All" };

  var aUserInDB = approveUserList?.map((aUser, idx) => {
    return {
      value: aUser?.username+"-"+aUser?.emp_id,
      label: aUser?.username+"-"+aUser?.emp_id,
    };
  });

  const { currentProjects } = useProjectStore();        

  const projectData = currentProjects?.map((member, idx) => {
        return {
            value:member.projectname,
            label:member.projectname,
        };
    });

  const initFilterfromStore = () => {
      var filterObj = getSettingByKey(filtername)
      //console.log("filterObj",filterObj)
      if( filterObj != null){
      
        if(filterObj.value.year != undefined) 
       setFilterYear(filterObj.value.year)

       if(filterObj.value.month != undefined) 
       setFilterMonth(filterObj.value.month)

       if(filterObj.value.project != undefined) 
       setFilterProject(filterObj.value.project)

       if(filterObj.value.users != undefined) 
       setFilterUser(filterObj.value.users)
      }
  };

  const getUserId =(userName,empid) =>{
    for (let idx = 0; idx < approveUserList?.length; idx++) {
      if (approveUserList[idx]?.username === userName) {
        return approveUserList[idx].qhuid;
      }
    }    
  }
  const getDataforFilter = () => {
    let encodedJsonValues = {};
    encodedJsonValues.project = filterParamProjects;
    encodedJsonValues.projectid = "Not Supported";
    if((initUsers)&&(filterParamUser != "") && (filterParamUser != "Please Select")){
        const answer_array = filterParamUser?.split('-');
        var userName = answer_array[0]
        var empid = answer_array[1]
        encodedJsonValues.username = userName;
        encodedJsonValues.qhuid = getUserId(userName,empid);
    } else
    {
       encodedJsonValues.username = filterParamUser;
       encodedJsonValues.qhuid ="";
    }
    
    encodedJsonValues.month = filterParamMonth?.toString();
    encodedJsonValues.year = filterParamYear?.toString();
    if(handleFilter != null)
       handleFilter( encodedJsonValues);
  };

   const handleUpdateFilter = () => {
    let encodedJsonValues = {};
    encodedJsonValues =getDataforFilter()
    //update store
    let filterSettings = {"key":filtername, "value":encodedJsonValues}
    //addOrUpdateSetting(filterSettings)
  };

  const updateAUserList = () => {
      //console.log("Flag is set")
      aUserInDB = approveUserList?.map((aUser, idx) => {
        return {
          value: aUser?.username+"-"+aUser?.emp_id,
          label: aUser?.username+"-"+aUser?.emp_id,
        };
      });
      if(allUsers){
          aUserInDB?.push(aUserAll);
      }
      aUserInDB != null ? setAUserList([...aUserInDB]) : setAUserList();
  }

  useEffect(() => {
    initFilterfromStore()
    if (enableUsers == true)
        getTeamTimeSheetAproveUsersList();
    else{
      updateAUserList()
      getDataforFilter();   
    }   
  }, []);
  
  useEffect(() => {
    if(approveUserListFlag){
      //console.log("Flag is set")
      updateAUserList()
      getDataforFilter();
      resetAprroveUsersListFlag()
    }
  }, [approveUserListFlag]);

  const handleFilterYear = (value) => {
    setFilterYear(value?.$y);
  };
  const handleFilterMonth = (value) => {
    setFilterMonth(value?.$M);
    setFilterYear(value?.$y);

     console.log("Selected Month", value?.$M,value?.$y)
  };
  const handleFilterProject = (value) => {
    setFilterProject(value);
  };
  const handleFilterUser = (value) => {
    setFilterUser(value);
  };

  return (
    <>
      <div className="generic-filter">
        <div className="teamTask-filter-item-wrapper">
          <div className="teamTask-filter-item-label"></div>
          {(enableProject || enableUsers || enableMonths) && (
            <div className="teamTask-filter-item" style={{ margin: "13px" }}>
              <Button onClick={handleUpdateFilter}>Update Now</Button>
            </div>
          )}
        </div>
        <div className="teamTask-filter-item-wrapper">
          {enableUsers && (
            <>
              <div className="teamTask-filter-item-label">Users</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30, textAlign: "left" }}
                  onChange={handleFilterUser}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  placeholder={initUsers}
                  options={aUserList}
                />
              </div>
            </>
          )}
        </div>
        <div className="teamTask-filter-item-wrapper">
          {enableProject && (
            <>
              <div className="teamTask-filter-item-label">Projects</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30, textAlign: "left" }}
                  onChange={handleFilterProject}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  placeholder={initProject}
                  options={projectData}
                />
              </div>
            </>
          )}
        </div>        
        <div className="teamTask-filter-item-wrapper">
          {enableMonths && (
            <>
            <div className="teamTask-filter-item-label">Select Month</div>
            <Space direction="vertical">
               <DatePicker onChange={handleFilterMonth} defaultValue={dayjs()} picker="month" />
            </Space>
            </>
          )}
        </div> 
        <div className="teamTask-filter-item-wrapper">
          {enableYear && (
            <>
            <div className="teamTask-filter-item-label">Select Year</div>
            <Space direction="vertical">
               <DatePicker onChange={handleFilterYear} defaultValue={dayjs()} picker="year" />
            </Space>
            </>
          )}
        </div>                 
      </div>
    </>
  );
}

export default FilterTimeSheet;
